'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLanguage = function MdLanguage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.3 23.4h5.6c0.2-1.1 0.5-2.2 0.5-3.4s-0.3-2.3-0.5-3.4h-5.6c0.1 1.1 0.2 2.2 0.2 3.4s-0.1 2.3-0.2 3.4z m-3 9.2c3-1 5.7-3.2 7.3-6h-5c-0.5 2.2-1.3 4.1-2.3 6z m-0.4-9.2c0.2-1.1 0.2-2.2 0.2-3.4s0-2.3-0.2-3.4h-7.8c-0.2 1.1-0.2 2.2-0.2 3.4s0 2.3 0.2 3.4h7.8z m-3.9 9.9c1.4-2 2.5-4.2 3.2-6.7h-6.4c0.7 2.5 1.8 4.7 3.2 6.7z m-6.6-19.9c0.5-2.2 1.3-4.1 2.3-6-3 1-5.7 3.2-7.3 6h5z m-5 13.2c1.6 2.8 4.3 5 7.3 6-1-1.9-1.8-3.9-2.3-6h-5z m-1.3-3.2h5.6c-0.1-1.1-0.2-2.2-0.2-3.4s0.1-2.3 0.2-3.4h-5.6c-0.2 1.1-0.5 2.2-0.5 3.4s0.3 2.3 0.5 3.4z m12.9-16.7c-1.4 2.1-2.5 4.2-3.2 6.7h6.4c-0.7-2.5-1.8-4.6-3.2-6.7z m11.6 6.7c-1.6-2.8-4.3-5-7.3-6 1 1.9 1.8 3.9 2.3 6h5z m-11.6-10c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z' })
        )
    );
};

exports.default = MdLanguage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/language.js
// module id = 3222
// module chunks = 0